//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'TechMeetup#4 Java/JVM',
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'TechMeetup#4 Java/JVM',
  description: [
    'Привет, коллега! <img style="margin-right:1040px" width="30" height="20" src="assets/image-block/freehand.png"  align="right">',
    '<img style="margin-right:10px" width="30" height="20" src="assets/image-block/freerocket.png"  align="left"> TechMeetup #4, посвященный Java и экосистеме JVM, состоится 26 апреля в онлайн и офлайн форматах.',
    '<img style="margin-right:10px" width="30" height="20" src="assets/image-block/freejava.png"  align="left"> Мы подготовили насыщенную программу, включающую доклады о разработке на Java и об экосистеме JVM.',
    'Приглашаем всех, кто занимается разработкой или интересуется этой областью.',
    '<img style="margin-right:10px" width="30" height="20" src="assets/image-block/freepeople.png"  align="left"> Увлекательные доклады, нетворкинг, а также призы и дружеское афтепати с угощениями и напитками - у нас есть всё, что нужно.',
    '<img style="margin-right:10px" width="30" height="20" src="assets/image-block/freemicrophone.png"  align="left"> Давно мечтал выступить на митапе? Не упусти эту возможность! Мы готовы помочь и поддержать тебя в подготовке к выступлению на будущих мероприятиях.',
    '<b>Посмотри доклады:</b>',
    '<ul> <li>Дмитрий Смирнов: <a href="https://sigma.disk.t1.cloud/public/InnXSA_I " target="_blank">SpringModulith</a> </li>  <li> Александр Митин: <a href="https://sigma.disk.t1.cloud/public/JgWJoA_I " target="_blank">Как осознать ошибки. Формирование ответа сервиса, если что-то пошло не так.</a> </li>  <li> Марк Шевченко: <a href="https://sigma.disk.t1.cloud/public/fua5XA_I " target="_blank">Какие вопросы задавать на техническом интервью?</a> </li>',
    '',
    ''
  ],
  date: '26 апреля 2024',
  time: '18:30 - 22:00'
  },
  activities: [
    {
      tabName: '15.06.3023', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'qBfXhtHY',
          id: 2420,
          hallName: 'Первый зал' // название зала
        }
      ]
    }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как пройти', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/Map.cad82bee.png'), // путь до изображения для блока с картинкой
    items: [
      'м. Красносельская/Бауманская, Спартаковский переулок 2с1, подъезд №7 (арт-пространство "Весна", 2 этаж).',
      '',
      '<a href="https://yandex.ru/maps/213/moscow/house/spartakovskiy_pereulok_2s1/Z04YcABiSkIOQFtvfXt2eXhrYw==/?ll=37.672379%2C55.778487&source=serp_navig&utm_source=share&z=16" target="_blank">Яндекс.Карты</a>'
    ]
  },
  info: {
    title: 'О нас', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<b>Т1 Интеграция</b> входит в <b>Холдинг Т1</b>, является одним из лидеров рынка системной интеграции в России, обладает большим набором компетенций, подтверждённых официальными статусами от ключевых мировых и отечественных производителей и разработчиков. Компания создана в 1992 году. Продуктовый портфель компании включает свыше 130 продуктов и услуг в области системной интеграции, промышленного инжиниринга, информационной безопасности, сетевых технологий и пр. Компанией реализовано более 2000 проектов в интересах заказчиков – государственных структур и крупнейших компаний ключевых отраслей экономики. <b>Центр компетенций по вычислительным комплексам</b> оказывает услуги по реализации проектов полного цикла, связанных с построением и модернизацией ИТ-инфраструктуры заказчиков. <a href="https://t1.ru/competencies/item/vychislitelnye-kompleksy/" target="_blank">Подробнее</a>',
      '',
      'Компания <b>"МФТ Платформа"</b> создана в 2006 году и занимается разработкой высокопроизводительных серверных систем для передачи данных по сети Интернет. Основной упор делается на безопасность пересылки информации и удобство администрирования сопутствующих бизнес-процессов. Комплекс «Ромашка» отвечает за предоставление доступа и транспортировку файлов различными способами, управление и контроль этих процессов, автоматизацию, а также безопасную передачу файлов в процессе транспортировки. При этом сами ресурсы хранения (СХД, файловые серверы и пр.) не являются частью ПК «Ромашка».',
      '<p><hr / color="#00AAE6"></br>',
      'В наших аккаунтах: новости, кейсы, тренды и экспертная аналитика. </br></br> <a href="https://habr.com/ru/companies/T1Holding/articles/"><img style="margin-right:50px" src="assets/image-block/habr.png" </a><a href="https://t.me/T1Holding"><img style="margin-right:50px" " src="assets/image-block/tg.png"</a>',
      'Подписывайтесь!'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,'
    // phone: '+7 926 260 53 22'
  }
}
